class Errors {
	constructor () {
		this.errors = {}
	}

	get (field) {
		return this.errors[field][0]
	}

	has (field) {
		return this.errors.hasOwnProperty(field)
	}

	record (errors) {
		this.errors = errors
	}

	clear (field) {
		if (field) {
			delete this.errors[field]
			return
		}

		this.errors = {}
	}

	any () {
		return Object.keys(this.errors).length
	}
}

export default Errors